<template>
    <div class="modal-content-padding">
        <div class="col ml-3w">
            <!-- TITLE -->
            <div class="row">
                <h5>{{ $t('reservation_created') }}</h5>
            </div>
            <!-- CONTENT -->
            <div class="row">PIN: {{ reservation.pin }}</div>
            <!-- BUTTONS -->
            <div class="row mt-3">
                <div class="d-flex mr-4">
                    <button class="btn btn-danger" @click="handleCloseClick()">
                        {{ $t('close') }}
                    </button>
                </div>
                <div class="d-flex">
                    <button class="btn btn-info" @click="handlePrintClick()">
                        {{ $t('print_close') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { printSticker } from '@/services/reservationService';

export default {
    props: {
        reservation: {
            type: Object,
            required: true
        }
    },
    data() {
        return {};
    },
    methods: {
        // close modal and redirect to reservations index
        exit() {
            this.$router.push({ name: 'reservation.index' });
            this.$emit('close');
        },
        // handle "close" click
        handleCloseClick() {
            this.exit();
        },
        // handle "print" click
        handlePrintClick() {
            printSticker(this.reservation);
            this.exit();
        }
    }
};
</script>
